const Adjectives = Object.freeze([
  'Adorable',
  'Adored',
  'Angry',
  'Clever',
  'Clumsy',
  'Confused',
  'Dashing',
  'Dizzy',
  'Elegant',
  'Funny',
  'Glowing',
  'Happy',
  'Mysterious',
  'Notorious',
  'Running',
  'Slow',
  'Smooth',
  'Spooky',
  'Stubborn',
  'Suspicious',
  'Swimming',
  'Tired',
  'Triumphant',
  'Upset',
  'Yummy',
]);

export { Adjectives };
